import React from "react";
import "./loader.css";
export const Loader = () => {
  return <div className="lds-dual-ring"></div>;
};
